import { useToggle } from "hooks/useToggle";
import ProgressBar from "ds/components/ProgressBar";
import Box from "ds/components/Box";
import CollapsibleSection from "ds/components/CollapsibleSection";
import useUserGuideGroups from "shared/UserGuides/useUserGuideGroups";

import LaunchPadLearnGroupTile from "./GroupTile";
import LaunchPadLearnSkeleton from "./Skeleton";

const LaunchPadLearn = () => {
  const [isCollapsed, handleToggle] = useToggle(false);

  const { userGuideGroups, userGuidesCompletedCount, userGuidesCount, loading } =
    useUserGuideGroups();

  return (
    <CollapsibleSection
      title="Learn"
      onToggle={handleToggle}
      isCollapsed={isCollapsed}
      headerSuffix={
        <ProgressBar
          ariaLabel="Number of completed features"
          max={userGuidesCount}
          current={userGuidesCompletedCount}
          isPercentage
        />
      }
      ariaLevel={2}
      ariaLabel="Learn"
    >
      <Box grid gridTemplate="1fr 1fr" gap="large">
        {loading && !userGuideGroups ? (
          <LaunchPadLearnSkeleton />
        ) : (
          userGuideGroups?.map(
            ({
              id,
              name,
              icon,
              color,
              skillLevel,
              description,
              timeToComplete,
              guidesCount,
              guidesCompletedCount,
            }) => (
              <LaunchPadLearnGroupTile
                key={id}
                title={name}
                icon={icon}
                backgroundColor={color}
                to={`/launchpad/learn/${id}`}
                skillLevel={skillLevel || undefined}
                description={description}
                timeToComplete={timeToComplete}
                guidesCount={guidesCount}
                guidesCompletedCount={guidesCompletedCount}
              />
            )
          )
        )}
      </Box>
    </CollapsibleSection>
  );
};

export default LaunchPadLearn;
